import { render } from "./basket_component.vue?vue&type=template&id=7ca42f0c&scoped=true"
import script from "./basket_component.vue?vue&type=script&lang=js"
export * from "./basket_component.vue?vue&type=script&lang=js"

import "./basket_component.vue?vue&type=style&index=0&id=7ca42f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca42f0c"]])

export default __exports__